import client, { Response } from './client';
import { AgentData } from '../../types/agent';
import axios from 'axios';

export type AccessTokenData = {
  access_token: string;
  expires_in: number;
  refresh_expires_in: null | number;
};

export type LoginRequestParams = {
  email: string;
  password: string;
};

export const logIn = (data: LoginRequestParams): Response<AccessTokenData> =>
  client.post(`/login`, data).then((response) => {
    const token = response.data.access_token;

    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    client.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    client.defaults.headers['Authorization'] = `Bearer ${token}`;

    return response;
  });

export const loadProfile = (): Response<AgentData> => client.get(`/profile`);
